import { useState } from 'react';
import { Trans } from '@lingui/react/macro';

import RefashionLogo, { RefashionStatus } from '@/components/RefashionLogo';
import Button from '@/design_system/Button';
import Stack from '@/design_system/Stack';
import Paragraph from '@/design_system/Typography/Paragraph';
import IconChevron from '@/icons/Chevron.svg';
import { I18nWording, useDatabaseTranslation } from '@/services/i18n';

const PackActionName = ({
  packActionType,
  duplicateActionNumber,
  alwaysShowActions = false,
  style,
  disabled = false,
}: {
  packActionType: {
    name: I18nWording;
    actions: {
      id: string;
      name: I18nWording;
      refashionStatus?: RefashionStatus;
    }[];
  };
  duplicateActionNumber?: number;
  alwaysShowActions?: boolean;
  style?: React.CSSProperties;
  disabled?: boolean;
}) => {
  const { _db } = useDatabaseTranslation();

  const [showActions, setShowActions] = useState(alwaysShowActions);

  return (
    <Stack style={style}>
      <Paragraph weight="medium" color={disabled ? 'disabled' : undefined}>
        {_db(packActionType.name)}
        {!!duplicateActionNumber && ` #${duplicateActionNumber}`}
      </Paragraph>
      {!alwaysShowActions && (
        <Button
          variant="link-subtle"
          size="small"
          style={{ justifyContent: 'flex-start' }}
          onPress={() => setShowActions((prev) => !prev)}
        >
          {showActions ? (
            <>
              <Trans id="components.action-type-search-select.pack-action.hide">
                Hide action details
              </Trans>
              <IconChevron up />
            </>
          ) : (
            <>
              <Trans id="components.action-type-search-select.pack-action.show">
                Show action details
              </Trans>
              <IconChevron down />
            </>
          )}
        </Button>
      )}
      {showActions && (
        <ul>
          {packActionType.actions.map((action) => (
            <li key={action.id}>
              <Paragraph size="200" color={disabled ? 'disabled' : undefined}>
                {_db(action.name)}
              </Paragraph>
              {!!action.refashionStatus && (
                <>
                  {' '}
                  <RefashionLogo status={action.refashionStatus} />
                </>
              )}
            </li>
          ))}
        </ul>
      )}
    </Stack>
  );
};

export default PackActionName;
